const APP_PREFIX = 'pharmalytic_'
export class LocalStorageManager {
  static addItem(key: string, value: unknown): void {
    try {
      const serializedValue = JSON.stringify(value)
      localStorage.setItem(`${APP_PREFIX}${key}`, serializedValue)
    } catch (error) {
      console.error('Error adding item to localStorage', error)
    }
  }

  static getItem<T>(key: string): T | null {
    try {
      const serializedValue = localStorage.getItem(`${APP_PREFIX}${key}`)
      if (serializedValue === null) {
        return null
      }
      return JSON.parse(serializedValue) as T
    } catch (error) {
      console.error('Error getting item from localStorage', error)
      return null
    }
  }

  static removeItem(key: string): void {
    try {
      localStorage.removeItem(`${APP_PREFIX}${key}`)
    } catch (error) {
      console.error('Error removing item from localStorage', error)
    }
  }

  static clearAll(): void {
    try {
      localStorage.clear()
    } catch (error) {
      console.error('Error clearing localStorage', error)
    }
  }

  static clearPrefix(prefix: string): void {
    try {
      const keys = Object.keys(localStorage)
      keys.forEach((key) => {
        if (key.startsWith(`${APP_PREFIX}${prefix}`)) {
          localStorage.removeItem(key)
        }
      })
    } catch (error) {
      console.error('Error clearing localStorage with prefix', error)
    }
  }
}
